<div id="common-table" class="common-table">
  <p-table
    #lmsTable
    [dataKey]="dataKey"
    [columns]="columnData"
    [autoLayout]="true"
    [value]="tableData"
    [paginator]="paginator"
    [rows]="l"
    [scrollable]="scrollable"
    [scrollHeight]="scrollHeight"
    (onPage)="pageChanged($event)"
    [globalFilterFields]="searchFields"
    [(first)]="first"
    (sortFunction)="customSort($event)"
    [customSort]="true"
    [sortField]="defaultSortField"
    [sortOrder]="defaultSortOrder"
    [rowsPerPageOptions]="[10, 25, 50, 75, 100]"
    [tableStyle]="{ 'min-width': '50rem' }"
  >
    <ng-template pTemplate="caption" *ngIf="enableSearch">
      <div class="p-col-12 p-md-5">
        <input
          pInputText
          type="text"
          (input)="lmsTable.filterGlobal($event.target.value, 'contains')"
          placeholder="{{ searchPlaceHolder }}"
        />
        <em class="pi pi-search"></em>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr *ngIf="enableSort">
        <th
          *ngFor="let col of columns"
          id="lms-col"
          [ngStyle]="{
            width: col.colWidth != undefined ? col.colWidth : 'initial',
            cursor: col.enableSort ? 'pointer' : 'auto'
          }"
          [pSortableColumn]="col.enableSort ? col.field : null"
        >
          <p-sortIcon
            class="sort-icon"
            *ngIf="col.field !== 'checkbox' && enableSort && col.enableSort"
            [field]="col.field"
          ></p-sortIcon>
          <span
            *ngIf="col.field !== 'checkbox'"
            [ngStyle]="{
              color: col.isActive === false ? '#505050' : '#6e6e6e !important'
            }"
            >{{ col.header }}</span
          >
          <div class="tbl-th-checkbox">
            <mat-checkbox
              *ngIf="col.field === 'checkbox'"
              (change)="headerCheckBoxEvent($event)"
              [(ngModel)]="allChecked"
              [disabled]="disableCheckbox"
              [indeterminate]="!allChecked && selected"
            >
            </mat-checkbox>
          </div>
        </th>
      </tr>
      <tr *ngIf="!enableSort">
        <th
          *ngFor="let col of columns"
          id="lms-col"
          [ngStyle]="{
            width: col.colWidth != undefined ? col.colWidth : 'initial'
          }"
        >
          <span
            *ngIf="col.field !== 'checkbox'"
            [ngStyle]="{
              color: col.isActive === false ? '#505050' : '#6e6e6e !important'
            }"
            >{{ col.header }}</span
          >
          <div class="tbl-th-checkbox">
            <mat-checkbox
              *ngIf="col.field === 'checkbox'"
              (change)="headerCheckBoxEvent($event)"
              [(ngModel)]="allChecked"
              [disabled]="disableCheckbox"
              [indeterminate]="!allChecked && selected"
            >
            </mat-checkbox>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowData
      let-columns="columns"
      let-index="rowIndex"
    >
      <tr class="tr-clr">
        <td
          *ngFor="let col of columns"
          [ngStyle]="{
            width: col.colWidth != undefined ? col.colWidth : 'initial'
          }"
        >
          <span *ngIf="col.field === 'checkbox'">
            <mat-checkbox
              #tableCheckBox
              (change)="rowCheckBoxEvent($event, rowData)"
              [disabled]="disableCheckbox"
            ></mat-checkbox>
          </span>
          <span
            *ngIf="col.type === 'link'"
            id="tbl-link"
            class="link"
            (click)="onLinkClick(rowData)"
          >
            {{ rowData[col.field] }}
          </span>
          <span
            *ngIf="col.type === 'link-number'"
            id="tbl-link"
            class="link"
            (click)="onLinkNumberClick(rowData)"
          >
            {{ rowData[col.field] }}
          </span>
          <span
            [ngClass]="{
              'state-ack': rowData[col.field] === 'Acknowledge',
              'state-new': rowData[col.field] === 'New'
            }"
            *ngIf="
              (col.type === 'text' || col.type === 'number') &&
              col.field !== 'entitlementStatus'
            "
            (click)="onTextClick(rowData)"
          >
            {{ rowData[col.field] }}
          </span>
          <span
            [ngClass]="{
              'comp-filestatus': rowData[col.field] === 'Completed',
              'error-filestatus': rowData[col.field] === 'Error',
              'inprog-filestatus': rowData[col.field] === 'In Progress'
            }"
            *ngIf="col.type === 'fileStatus'"
          >
            {{ rowData[col.field] }}
          </span>
          <span
            [ngStyle]="{
              color: rowData[col.field] === 'Inactive' ? '#ED1B2F' : '#00D621'
            }"
            *ngIf="col.field === 'entitlementStatus'"
          >
            {{ rowData[col.field] }}
          </span>
          <span *ngIf="col.type === 'text-desc'" class="text-desc-header">
            {{ rowData[col.field].headerText }}
            <div class="text-desc">
              {{ rowData[col.field].desc }}
            </div>
          </span>
          <span
            *ngIf="col.type === 'tooltipNum'"
            pTooltip="Range: {{ rowData[col.field].range }}"
            tooltipPosition="bottom"
            [tooltipDisabled]="
              rowData[col.field].tooltipDisabled === 'false' ? false : true
            "
            [ngClass]="{
              'tooltip-num':
                rowData[col.field].value > rowData[col.field].maxRange ||
                rowData[col.field].minRange > rowData[col.field].value
            }"
          >
            {{ rowData[col.field].value }}
          </span>
          <span
            *ngIf="
              col.type === 'icon' &&
              rowData[col.field] &&
              rowData[col.field].iconName === 'ellipsis'
            "
          >
            <button
              id="tbl-menu"
              class="mat-icon-button"
              [matMenuTriggerFor]="menu"
              aria-label="Example icon-button with a menu"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                id="tbl-menu-item"
                *ngFor="let item of rowData[col.field].iconActionList"
                (click)="actionClick(rowData, item)"
                mat-menu-item
              >
                <span>{{ item }}</span>
              </button>
            </mat-menu>
          </span>
          <span
            *ngIf="
              col.type === 'icon' &&
              rowData[col.field] &&
              rowData[col.field].iconName === 'lineChart'
            "
          >
            <em
              id="tbl-icon"
              (click)="onIconClick(rowData)"
              class="fa fa-line-chart chart-cursor"
              aria-hidden="true"
            ></em>
          </span>
    
          <span *ngIf="col.type === 'date' && (dataKey=='UTCDateFormat')">
            {{
              rowData[col.field] !== ""
                ? (rowData[col.field] | date : "dd/MM/yyyy, h:mm a":"+0000")
                : ""
            }}
          </span>


          <span *ngIf="col.type === 'date' && (dataKey==undefined)">
            {{
              rowData[col.field] !== ""
                ? (rowData[col.field] | date : "dd/MM/yyyy, h:mm a")
                : ""
            }}
          </span>
          <span
            *ngIf="col.type === 'status'"
            class="{{ rowData[col.field].statusStyle }}"
          >
            {{ rowData[col.field].statusName }}
          </span>
          <span *ngIf="col.type === 'statusIcon'">
            <em
              class="pi {{ col.icon }} connection-status-icon"
              [ngStyle]="{ color: rowData[col.field] }"
            ></em>
          </span>
          <span
            *ngIf="col.type === 'connectionStatus'"
            class="connection-status"
          >
            <span class="status-with-icon-txt"
              ><span *ngIf="rowData[col.field] != '-'"
                ><span
                  class="material-icons connection-status-icon"
                  *ngIf="rowData[col.field] != 'Not Connected'"
                  [ngStyle]="applyConnectionStatusStyle(rowData[col.field])"
                >
                  signal_cellular_4_bar </span
                ><span
                  class="material-icons connection-status-icon"
                  *ngIf="rowData[col.field] == 'Not Connected'"
                  [ngStyle]="applyConnectionStatusStyle(rowData[col.field])"
                  >signal_cellular_null</span
                ></span
              >{{ rowData[col.field] }}</span
            >
          </span>
          <span *ngIf="col.type === 'actionButton' && rowData[col.field]">
            <button
              id="btn-tbl-action"
              class="act-Button"
              pButton
              label="{{ rowData[col.field].label }}"
              icon="{{ rowData[col.field].actIconName }}"
            ></button>
          </span>
          <span *ngIf="col.type === 'dropDown'">
            <p-dropdown
              [disabled]="disableDropdown"
              appendTo="body"
              id="table-state"
              [ngClass]="{
                'ack-css': rowData[col.field].value === 'Acknowledge',
                'new-css': rowData[col.field].value === 'New'
              }"
              [options]="rowData[col.field].dropDownList"
              [placeholder]="rowData[col.field].value"
              optionLabel="name"
              (onChange)="changeState($event, rowData)"
            >
            </p-dropdown>
          </span>
          <span
            *ngIf="col.type === 'switch'"
            class="{{ rowData[col.field].statusStyle }}"
          >
            <p-inputSwitch
              [disabled]="disableSwitch"
              [(ngModel)]="rowData[col.field]"
              (onChange)="switchStatusChange(rowData)"
            ></p-inputSwitch
            ><span
              [ngClass]="{
                'lms-tbl-switch-active': rowData[col.field] === 'true',
                'lms-tbl-switch-inActive': rowData[col.field] === 'false'
              }"
            >
              {{ rowData[col.field] ? "Active" : "Inactive" }}
            </span>
          </span>
          <span
            *ngIf="col.type === 'tooltip-strings'"
            pTooltip="{{ rowData[col.field] }}"
            tooltipPosition="bottom"
            [tooltipDisabled]="
              rowData[col.field].split(',').length > 1 ? false : true
            "
          >
            {{
              rowData[col.field].split(",").length > 1
                ? rowData[col.field].split(",")[0] +
                  "+" +
                  (rowData[col.field].split(",").length - 1)
                : rowData[col.field]
            }}
          </span>
          <span
            *ngIf="
              col.type === 'download' && rowData[col.field] === 'Completed'
            ; " 
          
            (click)="downloadClick(rowData)"
          >
            <em
              id="download-icon"
              class="fa fa-download"
              aria-hidden="true"
            ></em>
            <a class="download-a">Download</a>
          </span>
        
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">No records found</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright">
      <span class="paginator-report"
        >Showing {{ totalRecords < 1 ? 0 : f + 1 }} -
        {{
          totalRecords > 0 ? (l + f <= totalRecords ? l + f : totalRecords) : 0
        }}
        of {{ totalRecords }} Entries</span
      >
    </ng-template>
  </p-table>
</div>
